<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Thirst at Night</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li><li id="toc-li-5"><a href="#/text/ch005#characters">Characters</a></li><li id="toc-li-6"><a href="#/text/ch006#finding-a-wife">Finding a Wife</a></li><li id="toc-li-7"><a href="#/text/ch007#the-dukes-castle">The Duke’s Castle</a></li><li id="toc-li-8"><a href="#/text/ch008#meeting-roseabella">Meeting Roseabella</a></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3fc705b2